export default __webpack_public_path__ + "static/media/icon_privacy_home_choice_icon-3.341a6e13.svg";